import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import SandboxDisplayPage from "@/pages/games/GameDisplay/children/sandboxes/SandboxDisplay/SandboxDisplayPage.vue";
import SandboxesListPage from "@/pages/games/GameDisplay/children/sandboxes/SandboxesList/SandboxesListPage.vue";

import links from "./links";

const { canReadSandboxes } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: ":sandboxId",
    component: SandboxDisplayPage,
    name: links.games.sandboxes.display,
    props: true,
    meta: {
      title: "Display Sandbox",
      permission: canReadSandboxes,
    },
  },
  {
    path: "",
    component: SandboxesListPage,
    name: links.games.sandboxes.list,
    props: true,
    meta: {
      title: "Sandboxes",
      permission: canReadSandboxes,
    },
  },
];
